module.exports = __webpack_public_path__ + "img/minpian3.bf197ed1.jpg";